import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { plannerSearchSchema } from '@/features/wedding-plan/components/planner-tabs'
import { PlanSectionPage } from '@/features/wedding-plan/pages/plan-section-page'
import { workspaceQueryOptions } from '@/lib/workspace'
export const Route = createFileRoute('/_auth/w/$workspaceSlug/decor')({
  validateSearch: plannerSearchSchema,
  component: Screen,
})
function Screen() {
  const { workspaceSlug } = Route.useParams()
  const workspace = useQuery(workspaceQueryOptions(workspaceSlug))
  return (
    <PlanSectionPage
      slug={workspaceSlug}
      section="decor"
      canWrite={workspace.data?.role === 'owner' || workspace.data?.role === 'editor'}
    />
  )
}
